import { render } from "./RecentTransactions.vue?vue&type=template&id=1cbb263c&ts=true"
import script from "./RecentTransactions.vue?vue&type=script&lang=ts"
export * from "./RecentTransactions.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__